const React = require("react");

const useId = require('@reach/auto-id').useId;

function InfoCircleIcon(props, svgRef) {
  const id = "InfoCircleIcon" + '_' + useId();
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 8.25a.75.75 0 00-.75.75v6a.75.75 0 101.5 0v-6a.75.75 0 00-.75-.75zm-.067-3.75a.925.925 0 10-.013 1.85.92.92 0 00.93-.924.926.926 0 00-.917-.926z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(InfoCircleIcon);
const MemoForwardRef = React.memo(ForwardRef);
module.exports = MemoForwardRef;